import colors from "@app/styles/_colors.module.scss";

export const ENTITY_BADGE_ALERT_COLOR = colors.red100;
export const ENTITY_BADGE_WARNING_COLOR = colors.yellow100;
export const ENTITY_BADGE_INFO_COLOR = colors.primary100;
